import axios from "axios";

export const state = {
    inventoryunits: [],
};

export const getters = {
    inventoryunits: state => state.inventoryunits,
};

export const mutations = {
    setInventoryunits(state, newValue) {
        state.inventoryunits = newValue
    },
};

export const actions = {
    fetchInventoryunits({ commit }) {
        axios.get('/inventoryunit').then(res => {
            commit('setInventoryunits', res.data.units)
        })
    },
};